import React, { useEffect, useRef } from 'react';
import { useAuth } from '../hooks/useAuth';
import { trackAuth } from '../utils/mixpanelTracking';

/**
 * Simple Mixpanel Auth Tracking - Only tracks login/logout once
 */
const MixpanelAuthWrapper = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const hasTrackedLogin = useRef(false);
  const hasTrackedLogout = useRef(false);

  // Handle user login/logout tracking - ONLY ONCE
  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated && user && !hasTrackedLogin.current) {
      trackAuth('login', user);
      hasTrackedLogin.current = true;
      hasTrackedLogout.current = false; // Reset logout flag
    } else if (!isAuthenticated && !hasTrackedLogout.current) {
      trackAuth('logout');
      hasTrackedLogout.current = true;
      hasTrackedLogin.current = false; // Reset login flag
    }
  }, [isAuthenticated, user, isLoading]);

  return <>{children}</>;
};

export default MixpanelAuthWrapper;